import React, { useEffect } from 'react'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { busquedaCpa, finalizarBusquedaCpa } from '../../actions'
import { FORM_BUSQUEDACPA } from '../../../../config/forms'
import { BusquedaCpa1 } from './steps'

function InfoCpa (props) {
  const { cpa, change: formChange, busquedaCpa, finalizarBusquedaCpa } = props

  useEffect(() => {
    finalizarBusquedaCpa()
    formChange('numero', cpa)
    busquedaCpa()
  }, [busquedaCpa, finalizarBusquedaCpa, cpa, formChange])

  return (
    <BusquedaCpa1
      handleClose={() => {}}
      noShowButton
    />
  )
}

const mapActionsToProps = ({
  busquedaCpa,
  finalizarBusquedaCpa
})

const withReduxForm = reduxForm({
  form: FORM_BUSQUEDACPA
})

const withRedux = connect(null, mapActionsToProps)
export default withRedux(withReduxForm(InfoCpa))
